import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs'; // <-- Importar throwError
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router) { }

  // ========================
  // LOGIN Y BLOQUEO OFFLINE
  // ========================
  login(credentials: any): Observable<any> {
    // Si no hay red, rechazamos la petición inmediatamente sin tocar el servidor
    if (!navigator.onLine) {
      return throwError(() => new Error('No hay conexión a internet. Conéctate para iniciar sesión.'));
    }
    return this.http.post(`${this.apiUrl}/auth/local`, credentials);
  }

  // ========================
  // GUARDAR SESIÓN (12 HORAS)
  // ========================
  guardarSesion(jwt: string, user: any) {
    const doceHoras = 12 * 60 * 60 * 1000;
    const exp = Date.now() + doceHoras;

    localStorage.setItem('token', jwt);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('jwt_exp', exp.toString());
  }

  // ========================
  // VALIDAR SESIÓN
  // ========================
  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const exp = localStorage.getItem('jwt_exp');

    if (!token || !exp) return false;

    // Si la hora actual superó la hora de expiración, el token caducó
    const isValid = Date.now() < Number(exp);

    if (!isValid) {
      this.logout();
      return false;
    }

    return true;
  }

  // ========================
  // OTROS MÉTODOS EXISTENTES
  // ========================
  obtenerUsuarioAutenticado(): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    return this.http.get(`${this.apiUrl}/users/me?populate=role`, { headers });
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('jwt_exp'); // <-- Limpiar también la expiración
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getRol(): string | null {
    const userString = localStorage.getItem('user');
    if (userString) {
      const user = JSON.parse(userString);
      return user.role?.name || null;
    }
    return null;
  }

  guardarTokenEnStrapi(tokenFirebase: string) {
    const userString = localStorage.getItem('user');
    const jwt = localStorage.getItem('token'); 
    
    if (userString && jwt) {
      const user = JSON.parse(userString);
      const userId = user.id;
      
      const url = `${this.apiUrl}/users/${userId}`;
      const body = { token: tokenFirebase }; 
      const headers = new HttpHeaders().set('Authorization', `Bearer ${jwt}`);

      this.http.put(url, body, { headers }).subscribe({
        next: (res) => console.log('🚀 Token de Push guardado en Strapi con éxito', res),
        error: (err) => console.error('❌ Error al guardar el token en Strapi', err)
      });
    }
  }
}